import useClearSelectionsOnChange from "./useClearSelectionsChange";

const ClearOnChange = () => {
    useClearSelectionsOnChange(); // auto-detects resource from ListContext
    return null;
};

export default ClearOnChange;